<div class="onboarding-submit-confirm-modal_header">
  <div class="onboarding-submit-confirm-modal_title">
    {{title | l10n}}
  </div>
  <svg class="onboarding-submit-confirm-modal_close-icon" (click)="close()"><use xlink:href="#close-large"></use></svg>
</div>
<div class="onboarding-submit-confirm-modal_body">
  <div class="onboarding-submit-confirm-modal_body_status_wrapper">
    <span class="onboarding-submit-confirm-modal_body_status">{{'components.onboarding-page.current_status_label' | l10n}}</span>
    <span class="onboarding-submit-confirm-modal_body_status {{displayOnboardingStatus?.styleClass}}">
      {{displayOnboardingStatus.label | l10n}}
    </span>
  </div>

  <div class="onboarding-submit-confirm-modal_body_status_description">
    @switch (displayOnboardingStatus.status) {
      @case (UserStatus.PENDING) {
        <p>{{'components.onboarding-page.current_status_pending_description' | l10n}}</p>
      }
      @case (UserStatus.APPROVED) {
        <p>{{'components.onboarding-page.current_status_approved_description_paragraph_1' | l10n}}</p>
        <p>{{'components.onboarding-page.current_status_approved_description_paragraph_2' | l10n}}</p>
      }
      @case (UserStatus.REJECTED) {
        <p>{{'components.onboarding-page.current_status_rejected_description' | l10n}}</p>
        @if (rejectReason) {
          <p>{{'components.onboarding-page.current_status_rejected_reason_label' | l10n}} {{rejectReason}}</p>
        }
      }
    }
  </div>
</div>

<div class="onboarding-submit-confirm-modal_footer">
  @if (!isDashboardPage && displayOnboardingStatus.status === UserStatus.APPROVED) {
    <a class="onboarding-submit-confirm-modal_button -back-to-dashboard" [routerLink]="['/']" (click)="close()">
      {{'components.onboarding-page.dashboard' | l10n}}
    </a>
  } @else {
    <button type="submit" class="onboarding-submit-confirm-modal_button -submit" (click)="close()">
      {{submitButtonText | l10n}}
    </button>
  }
</div>
